module.exports = __webpack_public_path__ + "img/sv108.21e4fe3b.svg";